"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _qa = require("./qa");
Object.keys(_qa).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _qa[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _qa[key];
    }
  });
});